module.exports = __webpack_public_path__ + "static/media/img_wear-remove-01.c40fe97d.svg";